// LocationMarker.js
import React from 'react';
import { Marker, InfoWindowF } from '@react-google-maps/api';

const LocationMarker = ({ location, isActive, onClick, onClose }) => {
    return (
        <Marker
            position={{ lat: location.latitude, lng: location.longitude }}
            onClick={onClick}
        >
            {isActive && (
                <InfoWindowF onCloseClick={onClose}>
                    <div className="text-[#392d23] p-1 max-w-xs">
                        <h2 className="text-base mb-1"><strong>{location.dba}</strong></h2>
                        <div className="text-sm leading-relaxed">{location.address}</div>
                        <div className="mt-2 text-sm">
                            <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#392d23] hover:text-[#5a4738] underline underline-offset-2"
                            >
                                Directions
                            </a>
                        </div>
                        {location.phone ? (
                            <div className="text-sm">
                                Phone: <a href={`tel:+1${location.phone}`} className="text-[#392d23] hover:text-[#5a4738] underline underline-offset-2">{location.phone}</a>
                            </div>
                        ) : null}
                    </div>
                </InfoWindowF>
            )}
        </Marker>
    );
};

export default LocationMarker;
